<template>
  <div class="overflow-hidden py-16 px-4 sm:px-6 lg:px-8">
    <div class="mx-auto max-w-max lg:max-w-7xl">
      <div class="relative z-10 mb-8 md:mb-2 md:px-6">
        <div class="max-w-prose text-base lg:max-w-none">
          <h2
            class="text-ontick-green-600 font-semibold uppercase leading-6 tracking-wide"
          >
            {{ data.title }}
          </h2>
          <p
            class="mt-2 text-3xl font-extrabold leading-8 tracking-tight sm:text-4xl"
          >
            {{ data.subtitle }}
          </p>
        </div>
      </div>
      <div class="relative">
        <div class="relative md:p-6">
          <div
            class="text-gray-500 dark:text-gray-400 lg:grid lg:grid-cols-2 lg:gap-6"
          >
            <div
              class="prose prose-indigo prose-lg space-y-6 lg:max-w-none"
              id="col1"
            >
              <p v-for="(paragraph, index) in data.col1" :key="index">
                {{ paragraph }}
              </p>
            </div>
            <div
              class="prose prose-indigo prose-lg mt-6 space-y-6 lg:mt-0"
              v-if="data.col2"
              id="col2"
            >
              <p v-for="(paragraph, index) in data.col2" :key="index">
                {{ paragraph }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
    },
  },
};
</script>
